import {View} from "../../km_app/types/View";
import {HomeMatchDetailsCtaVariant} from "../types/HomeMatchDetailsCtaVariant";
import {IHomeMatchState} from "../types/IHomeMatchState";

export const homeMatchDetailsModalInitialState: IHomeMatchState["detailsModal"] = {
    ctaVariant: HomeMatchDetailsCtaVariant.MY_INQUIRIES,
    isOpen: false,
    preleadId: null,
    viewType: View.HOME_MATCH
};
import {View} from "../../km_app/types/View";
import {HomeMatchDetailsCtaVariant} from "../types/HomeMatchDetailsCtaVariant";
import {IHomeMatchState} from "../types/IHomeMatchState";

export const homeMatchDetailsModalInitialState: IHomeMatchState["detailsModal"] = {
    ctaVariant: HomeMatchDetailsCtaVariant.MY_INQUIRIES,
    isOpen: false,
    preleadId: null,
    viewType: View.HOME_MATCH
};
